import ApplicationController from './application'

export default class extends ApplicationController {
  connect() {
    this.isDragging = false
    this.hasDragged = false
    this.startX = 0
    this.startY = 0
    this.scrollStartX = 0
    this.scrollStartY = 0
    
    // Bind methods to preserve context
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    
    // Add event listeners
    this.element.addEventListener('mousedown', this.onMouseDown)
    document.addEventListener('mouseup', this.onMouseUp)
    document.addEventListener('mousemove', this.onMouseMove)
    
    // Set initial cursor
    this.element.style.cursor = 'grab'
  }
  
  disconnect() {
    // Clean up event listeners
    this.element.removeEventListener('mousedown', this.onMouseDown)
    document.removeEventListener('mouseup', this.onMouseUp)
    document.removeEventListener('mousemove', this.onMouseMove)
  }
  
  onMouseDown(e) {
    // Skip if clicking on interactive elements - let them handle normally
    if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON' || 
        e.target.closest('a') || e.target.closest('button') ||
        e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') {
      return
    }
    
    this.isDragging = true
    this.hasDragged = false
    this.startX = e.pageX
    this.startY = e.pageY
    this.scrollStartX = this.element.scrollLeft
    this.scrollStartY = this.element.scrollTop
    this.element.style.cursor = 'grabbing'
    this.element.style.userSelect = 'none'
  }
  
  onMouseUp() {
    if (this.isDragging) {
      this.isDragging = false
      this.element.style.cursor = 'grab'
      this.element.style.userSelect = ''
    }
  }
  
  onMouseMove(e) {
    if (!this.isDragging) return
    
    const dx = e.pageX - this.startX
    const dy = e.pageY - this.startY
    
    // Only scroll if moved more than 3 pixels (to allow for slight mouse movement on click)
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
      this.hasDragged = true
      this.element.scrollLeft = this.scrollStartX - dx
      this.element.scrollTop = this.scrollStartY - dy
    }
  }
}
